import React from 'react';
import '../style/userLayout.css';
import BreadCrumb from "./breadcrumb";
import twitterIcon from '../assets/icons/twitter-black-shape-1.png';
import linkedInIcon from '../assets/icons/linked-in-logo.png';
import bloggerIcon from '../assets/icons/blogger-letter-logotype.png';
import youtubeIcon from '../assets/icons/youtube-symbol.png';
import { LAYOUT_FOOTER_TEXT, PRIVACY_URL, WEBSITE_TERMS_OF_USE,TWITTER_URL,BLOGGER_URL,LINKEDIN_URL,YOUTUBE_URL } from '../helpers/constants';

let frontEndVersion = require('../helpers/version');

const LayoutFooter = (props) => {
	const currentYear = new Date().getFullYear();
	return (
		<div className="row user-layout-footer print">
			<div className="row user-layout-footer-row-1">
				<a href={TWITTER_URL} target="_blank">
					<img className="user-layout-footer-icon" src={twitterIcon} alt=""/>
				</a>
				<a href={LINKEDIN_URL} target="_blank">
					<img className="user-layout-footer-icon" src={linkedInIcon} alt=""/>
				</a>
				<a href={BLOGGER_URL} target="_blank">
					<img className="user-layout-footer-icon" src={bloggerIcon} alt=""/>
				</a>
				<a href={YOUTUBE_URL} target="_blank">
					<img className="user-layout-footer-icon" src={youtubeIcon} alt=""/>
				</a>
			</div>
			<div className="row user-layout-footer-row-2">
				<BreadCrumb
					PathName={props.locationPathName}
					Push={props.push}
					BreadcrumbStyle="user-layout-footer-breadcrumb "
					Wrapper="user-layout-footer-breadcrumb-wrapper" />
			</div>
			<div className="row user-layout-footer-row-3">
				<div className="user-layout-footer-row-3-section-1" >
					<div dangerouslySetInnerHTML={{ __html: LAYOUT_FOOTER_TEXT }} />					
				</div>
				<br />
				<div className="user-layout-footer-row-3-section-2">
					<a className="user-layout-footer-row-link" href={PRIVACY_URL}
                       rel="noopener noreferrer"
                       target={'_blank'}> Privacy & Cookies |</a>
					<a className="user-layout-footer-row-link"
                       rel="noopener noreferrer"
                       href={WEBSITE_TERMS_OF_USE} target={'_blank'}> Website Terms of Use |</a>
					<a className="user-layout-footer-row-link"
					   rel="noopener noreferrer"
					   href="https://www.arag.co.uk/media/pdf/product_develop.process_map__external__june19.pdf"
					   target={'_blank'}> Product Development Process Map
					</a>
				</div>
				<br />
				<div className="user-layout-footer-row-3-section-4">{`${currentYear} ARAG`}</div>
				<br />
				<div>
					FV: {frontEndVersion.version} | BV: {props.backEndVersion}
				</div>
			</div>
		</div>
	)
};


export default LayoutFooter;